import {getGtmCollections, getGtmTags, getGtmAvailability} from './gtmUtils';
import {getGtmProductItemsData} from './getGtmProductItemsData';
import {
    GTM_SELECTOR_PRODUCT_TITLE,
    GTM_ATTRIBUTE_PRODUCT_SKU,
    GTM_SELECTOR_PRODUCT_PRICE,
    GTM_ATTRIBUTE_PRODUCT_PRICE,
    GTM_ATTRIBUTE_PRODUCT_URL,
    GTM_SELECTOR_IMAGE_URL,
    GTM_ATTRIBUTE_IMAGE_URL,
    GTM_ATTRIBUTE_PRODUCT_QUANTITY,
    GTM_SELECTOR_PRODUCT_QUANTITY,
    GTM_ATTRIBUTE_PRODUCT_COLLECTIONS,
    GTM_SELECTOR_PRODUCT_AVAILABILITY,
    GTM_ATTRIBUTE_PRODUCT_TAGS,
    GTM_ATTRIBUTE_PRODUCT_RATING,
    GTM_ATTRIBUTE_PRODUCT_REVIEWS,
    GTM_SELECTOR_PRODUCT_ID,
    GTM_ATTRIBUTE_PRODUCT_ID,
} from './gtmSelectors';

export const getGtmProductsList = (productsListElement) => {
    const analyticsData = JSON.parse(localStorage.getItem('analytics'));
    const taxRate = analyticsData?.tax_rate;
    const products = productsListElement?.querySelectorAll(GTM_SELECTOR_PRODUCT_ID);
    const productsArray = [];

    if (!products) {
        return [];
    }

    products.forEach((product) => {
        productsArray.push({
            id: Number(product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_ID)),
            sku: product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_SKU),
            title: product.querySelector(GTM_SELECTOR_PRODUCT_TITLE)?.innerText,
            presentment_price: Number(
                product.querySelector(GTM_SELECTOR_PRODUCT_PRICE)?.getAttribute(GTM_ATTRIBUTE_PRODUCT_PRICE),
            ) / 100,
            url: product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_URL),
            image: product.querySelector(GTM_SELECTOR_IMAGE_URL)?.getAttribute(GTM_ATTRIBUTE_IMAGE_URL) ?? '',
            quantity: Number(
                product.querySelector(GTM_SELECTOR_PRODUCT_QUANTITY)?.getAttribute(GTM_ATTRIBUTE_PRODUCT_QUANTITY),
            ),
            properties: {
                _analytics_data: {
                    categories: getGtmCollections(product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_COLLECTIONS)),
                    availability: getGtmAvailability(product.querySelectorAll(GTM_SELECTOR_PRODUCT_AVAILABILITY)),
                    flags: getGtmTags(product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_TAGS)),
                    rating: Number(product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_RATING)),
                    reviews: Number(product?.getAttribute(GTM_ATTRIBUTE_PRODUCT_REVIEWS)),
                },
            },
        });
    });

    return getGtmProductItemsData(productsArray, null, taxRate);
};
